import * as yup from 'yup';

const schema = () =>
  yup.object().shape({
    paymentType: yup.object().shape({
      label: yup.string(),
      value: yup.string().required('Please select the payment method'),
    }),
    paymentId: yup.string().required('Please enter a payment handle'),
  });

export default schema;
